import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import amTranslation from './locales/am/translation.json';
import enTranslation from './locales/en/translation.json';
import ruTranslation from './locales/ru/translation.json';

// eslint-disable-next-line
// @ts-ignore
i18n.use(initReactI18next).init({
  fallbackLng: 'am',
  resources: {
    en: { translation: enTranslation },
    ru: { translation: ruTranslation },
    am: { translation: amTranslation },
  },
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
